import { css } from "@emotion/react";

import { CSS_MQ } from "../../styles/breakpoints";
import { fontColor, FONTS, fontSize } from "../../styles/fonts";
import { CSS_COLORS } from "../../styles/styles-css-variables";

export const styles = css`
  ${FONTS.SwarovskiFutura300};
  ${fontColor.black};

  font-size: 21px;

  text-align: center;
  line-height: 26px;

  display: block;
  text-transform: uppercase;
  max-width: 34em;
  margin-left: auto;
  margin-right: auto;
`;

export const inBoxBigHeadline = css`
  ${FONTS.MinervaModern500};
  text-align: center;

  font-size: 24px;
  letter-spacing: 0.4px;
  line-height: 26px;
  ${CSS_MQ.atLeastMd} {
    font-size: 40px;
    letter-spacing: 2px;
    line-height: 42px;
  }

  color: ${CSS_COLORS.White};
  text-align: center;

  text-transform: uppercase;

  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const inBoxSmallHeadline = [
  FONTS.SwarovskiFutura500,
  fontSize.x2s,
  css`
    color: ${CSS_COLORS.White};
    text-align: center;

    text-transform: uppercase;

    margin-bottom: 0.5em;
  `,
];
